import type { FiscalRegimesDto } from '@subscriptions/application/dtos';

/** Renders a SAT fiscal regime as `612 - Descripción`, or the bare code until the catalog lists it. */
export const getTaxRegimeLabel = (satCode: string, fiscalRegimes?: FiscalRegimesDto): string => {
  const description = [...(fiscalRegimes?.taxRegimeCompany ?? []), ...(fiscalRegimes?.taxRegimePersons ?? [])].find(
    (regime) => regime.satCode === satCode,
  )?.description;

  return description ? `${satCode} - ${description}` : satCode;
};
